import * as d3 from 'd3';
import color, { polarAsCartesian } from "./helpers.js";
import {} from "d3";
const interpolatorFactory = (factory) => {
    return (a, b) => {
        const _a = factory(a); //the cast here keeps TS compiler quiet
        const _b = factory(b);
        const hs = polarAsCartesian(_a.h, _a.s, _b.h, _b.s);
        const l = color(_a.l, _b.l);
        const opacity = color(_a.opacity, _b.opacity);
        return (t) => {
            const _hs = hs(t);
            _a.h = _hs.angle;
            _a.s = _hs.length;
            _a.l = l(t);
            _a.opacity = opacity(t);
            return _a.toString();
        };
    };
};
export default interpolatorFactory;
export const interpolateHslLine = interpolatorFactory(d3.hsl);
